module.exports = __webpack_public_path__ + "static/media/happycodelogo.1ff2e91a.svg";